export * from './api/customers-api/constants';
export const SERVICE_KEY = 'customer-portal-api';
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=constants.js.map